module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/toshocard_next-6a0668b86584515cd37b02b67e82a34f.jpg";